/* eslint-disable no-param-reassign */
import { isEmpty } from '../../shared/helper-utils/appUtils';

export const seatGroupingHook = (SeatMap, flightLegsWithSeat) => {
  const flightlegs = flightLegsWithSeat;
  const seatMapArr = Array.isArray(SeatMap) ? SeatMap : [SeatMap];
  seatMapArr.forEach((seatMap) => {
    let sector;
    if (seatMap.ArrStation) {
      sector = `${seatMap.DepStation} - ${seatMap.ArrStation}`;
    } else {
      sector = `${seatMap.origin} - ${seatMap.destination}`;
    }
    const { seatrows } = seatMap;
    if (!isEmpty(seatrows)) {
      const seatsArray = Array.isArray(seatrows.SeatRow)
        ? seatrows.SeatRow
        : [seatMap.SeatRow];
      const digitArr = [];
      const letterArr = [];
      const aisleRows = {};
      const uniqueAisleRows = [];
      seatsArray.forEach((x) => {
        if (
          typeof x.seatdesignator === 'string' &&
          x.seatdesignator !== '' &&
          x.seatdesignator.indexOf('$') === -1
        ) {
          const digit =
            typeof x.seatdesignator === 'string'
              ? x.seatdesignator.replace(/\D/g, '')
              : '';
          const letter =
            typeof x.seatdesignator === 'string'
              ? x.seatdesignator.replace(/[^a-z]/gi, '')
              : '';
          const isAisle =
            x.additionalinfo
              ?.toLowerCase()
              ?.split(',')
              .some(
                (k) =>
                  k.indexOf('aisle') > -1 &&
                  k.indexOf('not') === -1 &&
                  k.indexOf('false') === -1,
              ) || x.seattype === 'Aisle';
          if (isAisle && letter !== undefined && letter !== '') {
            if (aisleRows[letter] === undefined) {
              aisleRows[letter] = 1;
            } else {
              aisleRows[letter] += aisleRows[letter];
              if (
                aisleRows[letter] > 2 &&
                uniqueAisleRows.indexOf(letter) === -1
              ) {
                uniqueAisleRows.push(letter);
              }
            }
          }

          if (
            digit !== undefined &&
            letter !== '' &&
            digitArr.indexOf(digit) === -1
          ) {
            digitArr.push(digit);
          }
          if (
            letter !== undefined &&
            letter !== '' &&
            letterArr.indexOf(letter) === -1
          ) {
            letterArr.push(letter);
          }
        }
      });
      letterArr.sort((a, b) => (a < b ? -1 : 1));
      uniqueAisleRows.sort((a, b) => (a < b ? -1 : 1));
      const filteredaisleRows = uniqueAisleRows.filter(
        (_, index) => index % 2 === 0,
      );
      digitArr.sort((a, b) => Number(a) < Number(b));
      digitArr.forEach((digitNum) => {
        letterArr.forEach((letterNum) => {
          const seatNum = `${digitNum}${letterNum}`;
          const isPresent = seatsArray.find((x) => {
            const digit =
              typeof x.seatdesignator === 'string'
                ? x.seatdesignator.replace(/\D/g, '')
                : '';
            const letter =
              typeof x.seatdesignator === 'string'
                ? x.seatdesignator.replace(/[^a-z]/gi, '')
                : '';
            return `${digit}${letter}` === seatNum;
          });
          if (!isPresent) {
            const noSeat = {
              additionalinfo: 'no-seat',
              columnnum: '',
              height: 2,
              paxseatprices: '',
              premiumseat: '',
              rownum: '',
              seatdesignator: seatNum,
              seatgroup: 98,
              seatprice: '',
              seatstatus: '',
              seattype: 'NS',
              width: 2,
              xval: 1,
              yval: 6,
            };
            seatsArray.push(noSeat);
          }
        });
      });
      const seatMapDict = seatsArray.filter(
        (x) => x.seatdesignator?.indexOf?.('$') === -1,
      );
      seatMapDict.forEach((x) => {
        const letter =
          typeof x.seatdesignator === 'string'
            ? x.seatdesignator.replace(/[^a-z]/gi, '')
            : '';
        if (filteredaisleRows.indexOf(letter) > -1) {
          x.additionalinfo += `,margin-left`;
        }
      });
      const result = {};

      // Initialize the result object with empty arrays for each digit
      digitArr.forEach((digit) => {
        result[digit] = [];
      });

      // Iterate over the array of objects and group them by digit
      seatMapDict.forEach((seatObj) => {
        const match = seatObj.seatdesignator.match(/(\d+)-?(\w+)/); // Extract the numeric part and the letter part of the seat
        if (match) {
          const digit = parseInt(match[1], 10);
          if (result[digit]) {
            result[digit].push(seatObj);
          }
        }
      });

      // Sort the seats within each digit group alphabetically by seat string
      Object.values(result).forEach((seatGroup) => {
        seatGroup.sort((a, b) =>
          a.seatdesignator.localeCompare(b.seatdesignator),
        );
      });
      flightlegs[sector] = {
        seats: result,
        seatDigitArray: digitArr,
        seatLetterArray: letterArr,
      };
    }
  });
  return flightlegs;
};

export const ssrGroupingHook = (
  response,
  flightlegsWithMeal,
  flightlegsWithBaggage,
  flightlegsWithSpecialssr,
) => {
  const flightLegMeal = flightlegsWithMeal;
  const flightLegBaggage = flightlegsWithBaggage;
  const flightLegSpecialSsr = flightlegsWithSpecialssr;
  try {
    if (
      response &&
      response.list &&
      response.list !== null &&
      !isEmpty(response.list)
    ) {
      const { CarrierSSR } = response.list;
      if (!isEmpty(CarrierSSR)) {
        const list = Array.isArray(CarrierSSR) ? CarrierSSR : [CarrierSSR];
        const groupedBySector = list.reduce((acc, cur) => {
          if (cur.ArrStation) {
            cur.origin = cur.DepStation;
            cur.destination = cur.ArrStation;
          }
          if (
            (cur.origin !== 'all' &&
              cur.origin !== '' &&
              cur.origin !== undefined) ||
            (cur.destination !== 'all' &&
              cur.destination !== '' &&
              cur.destination !== undefined)
          ) {
            const key = `${cur.origin} - ${cur.destination}`;
            if (acc[key]) {
              acc[key].push(cur);
            } else {
              acc[key] = [cur];
            }
          }
          return acc;
        }, {});
        const sectors = Object.keys(groupedBySector);
        sectors.forEach((sector) => {
          const groupedData = groupedBySector[sector].reduce((acc, cur) => {
            if (acc[cur.ssrtype]) {
              acc[cur.ssrtype].push(cur);
            } else {
              acc[cur.ssrtype] = [cur];
            }
            return acc;
          }, {});
          if (groupedData.meal !== undefined) {
            groupedData.meal.sort(
              (meal1, meal2) => meal1.chargeableamount - meal2.chargeableamount,
            );
            flightLegMeal[sector] = groupedData.meal;
          }
          if (groupedData.baggage !== undefined) {
            groupedData.baggage.sort(
              (baggage1, baggage2) =>
                baggage1.chargeableamount - baggage2.chargeableamount,
            );
            flightLegBaggage[sector] = groupedData.baggage;
          }
          if (groupedData.specialssr !== undefined) {
            const speicalSsrList = groupedData.specialssr;
            speicalSsrList.sort(
              (baggage1, baggage2) =>
                baggage1.chargeableamount - baggage2.chargeableamount,
            );
            flightLegSpecialSsr[sector] = speicalSsrList;
          }
        });
      }
    }
    return { flightLegMeal, flightLegBaggage, flightLegSpecialSsr };
  } catch (error) {
    return { flightLegMeal, flightLegBaggage, flightLegSpecialSsr };
  }
};
